// Shared horizontal shell for the public marketing surface.
export const MARKETING_CONTAINER =
  'mx-auto w-full max-w-[1240px] px-6 sm:px-8 lg:px-12 xl:px-16';
